import Footer from 'components/Generics/Footer/Footer';
import Header from 'components/Generics/Header/EtoHeader';
import React from 'react';
import * as S from 'components/Logout/EtoLogout.style';
import { Trans, useTranslation } from 'react-i18next';

const EtoLogout = (): React.ReactElement => {

    const { t } = useTranslation();
    const etoLogoutMSG = t('public:ETO_LOGOUT_MSG');
    return (
        <S.EtoBackground>
            <Header />
            <S.Content>
                <S.EtoLogoutMsg>
                    <Trans>{ etoLogoutMSG }</Trans>
                </S.EtoLogoutMsg>
            </S.Content>
            <Footer />
        </S.EtoBackground>
    );
};

export default EtoLogout;